module.exports = __webpack_public_path__ + "img/color-6.04232b9.png";